import { render, staticRenderFns } from "./MantenedorLocalidadPantalla.vue?vue&type=template&id=6307691c&"
import script from "./MantenedorLocalidadPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorLocalidadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports